import React from "react";
import PropTypes from "prop-types";
import DingoEnergyChart from "../DingoEnergyChart";
import moment from "moment";
import * as alertType from "../../model/alerts/alertTypeKeys";

const getDateRangeForWindow = alert => () => {
  const from = moment(alert.firstEventStarted)
    .subtract(1, "days")
    .startOf("day")
    .toDate();

  const now = new Date();

  let to = alert.lastEventDeactivated
    ? moment(alert.lastEventDeactivated)
        .add(1, "days")
        .endOf("day")
        .toDate()
    : now;

  if (to > now) {
    to = now;
  }

  return { from, to };
};

const AlertEnergyChart = props => {
  const sensor = props.alert.sensor;

  return (
    <DingoEnergyChart
      sensorId={sensor.sensorId}
      sensorDataSensorId={sensor.dingoId}
      showSeriesLabel={false}
      customWindows={["Alert"]}
      window="Alert"
      getDateRangeForWindow={getDateRangeForWindow(props.alert)}
      storeId={props.alert.store.storeId}
      lightsOverThresholdAlertThresholdsEnabled={
        props.alert.alertType.code === alertType.LIGHTS_OVER_THRESHOLD
      }
      hvacOverThresholdAlertThresholdsEnabled={
        props.alert.alertType.code === alertType.HVAC_OVER_THRESHOLD
      }
      sensor={sensor}
      hasAlerts
      {...props}
    />
  );
};

AlertEnergyChart.propTypes = {
  alert: PropTypes.shape({
    alertType: PropTypes.shape({
      code: PropTypes.string.isRequired
    }),
    sensor: PropTypes.shape({
      sensorId: PropTypes.string.isRequired
    }),
    firstEventStarted: PropTypes.string.isRequired,
    lastEventDeactivated: PropTypes.string,
    store: PropTypes.shape({
      storeId: PropTypes.string.isRequired
    })
  }).isRequired
};

export default AlertEnergyChart;
